<template>
    <div>
        <rkm-table
            :fields="fields"
            :items="data.model.textoPronto"
            ref="RkmTable"
            sort-by="codigo"
        >

        <template v-slot:cell(actions)="{ index, item }">

                <rkm-button
                    @click="$emit('handleAlter', index, item)"
                    color="primary"
                    title="Editar"
                    small
                >
                    <rkm-icon icon="pen" />
                </rkm-button>

                <rkm-button
                    @click.stop="handleDestroy(item)"
                    color="danger"
                    title="Excluir"
                    small
                >
                    <rkm-icon icon="trash" />
                </rkm-button>
            </template>
        </rkm-table>
    </div>
</template>

<script>

export default {
    computed:{
        validations() {
            return {
                valor: {max: 8},
            }
        },
        fields() {
            return [
                { key: 'codigo', label: 'Código', sortable: true },
                { key: 'descricao', label: 'Descrição', sortable: true },
                { key: 'actions', label: 'Ações', class: 'col-min text-center' },
            ]
        },
        items() {
            return [{
                codigo: '125',
                descricao: "Teste",
            }]
        },
        sexo() {
            return [
                {
                    id: 1,
                    descricao: "Masculino",
                },
                {
                    id: 2,
                    descricao: "Feminino",
                }
            ]
        },
    },
    props: {
        data: { type: Object, required: true },
    },
    data: () => ({
        filter: null,
        sexoId: null,
    }),
    methods: {
        validate() {
            return this.$refs.Form.validate()
        },
        openModal() {
            this.$refs.Modal.open()
        },
        handleDestroy(item) {

            const objId = this.data.model.textoPronto.findIndex((obj => obj.id == item.id));

            const destroy = async () => this.data.model.textoPronto.splice(objId, 1)

            this.showDeleteConfirmation('Deseja realmente excluir o registro?', destroy)
        },
    },
}
</script>